import { render, staticRenderFns } from "./dangjian.vue?vue&type=template&id=049f68d4&"
import script from "./dangjian.vue?vue&type=script&lang=js&"
export * from "./dangjian.vue?vue&type=script&lang=js&"
import style0 from "./dangjian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports